var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("作业打印")]),_c('el-button',{on:{"click":_vm.printHomework}},[_vm._v("打印作业")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }